module.exports = __webpack_public_path__ + "media/images/next-c5ab6485587a48ccbb3e1eeb82859740.png";